// PrivateRoute.tsx in v6
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import IgniteNavBar from "./IgniteNavBar";
import { isLoggedIn } from "../reducers/auth";
import { useSelector } from "react-redux";
import IgniteFooter from "./IgniteFooter";
import { getSubsite } from "../reducers/auth";

const AuthRoute = ({ children }) => {
  let navigate = useNavigate();
  const isLoggedInVal = useSelector(isLoggedIn);
  const currentSubsite = useSelector(getSubsite);
  
  useEffect(() => {
    if (!isLoggedInVal) {
      navigate("/home");
    }
  }, [navigate]);

  return (
    <>
      <IgniteNavBar />
      {children}
      <IgniteFooter menuBgColor={currentSubsite?.subsite_content?.menuBgColor} />
    </>
  ) 
};

export default AuthRoute;